/**
 * 구독 관리 액션 훅
 * FSD: features/subscription/subscription-manage/hooks
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionAPI } from '../api/subscription-api';

export const usePauseSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { id: string; reason?: string }) =>
      subscriptionAPI.pauseSubscription(data.id, data.reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
  });
};

export const useResumeSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => subscriptionAPI.resumeSubscription(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
  });
};

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { id: string; reason?: string }) =>
      subscriptionAPI.cancelSubscription(data.id, data.reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
    },
  });
};
